import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import useIsConnectedValues from "../hooks/useIsConnected";
const NetInfoStateContext = createContext(null);
export const useIsConnected = () => useContext(NetInfoStateContext);
const NetInfoProvider = (props) => (_jsx(NetInfoStateContext.Provider, { ...props, value: useIsConnectedValues() }));
export default NetInfoProvider;
